module.exports = __webpack_public_path__ + "static/media/border-left.7dcc8a50.svg";